<template>
  <div v-if="reconocimiento">
    <b-card>
      <titleSection
        title="Requisitos para Reconocimiento"
        subtitle=""
        icon="AwardIcon"
      />

      <b-card-text class="mt-2 mr-5 ml-1">
        <!-- eslint-disable vue/no-v-html -->
        <div v-html="reconocimiento" />
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BCardText,
} from 'bootstrap-vue'
import titleSection from '@/views/components/title-section.vue'

export default {
  components: {
    titleSection,
    BCard,
    BCardText,
  },
  props: {
    reconocimiento: {
      type: String,
      default: () => '',
    },
  },
}
</script>
